
import React from 'react'
import AvatarProfile from '../../components/avatar'
import AssetList from '../../components/assets'

const RiskApprovalPage = () => {
  return (
        <div className='w-screen'>
            <AvatarProfile />
            <AssetList type='risk' />
        </div>
  )
}

export default RiskApprovalPage
